import React from "react";
import styled from "styled-components";

import {
    IconInstagramWhite,
    IconFacebookWhite,
    IconTwitterWhite,
    // IconYoutubeWhite,
    IconTelegramWhite,
} from "~/src/components/icons/social";
import { down, colors } from "~/src/config/vars";

const SocialList = () => {
    const settings = {
        telegram: "https://t.me/ideaca",
        facebook: "https://www.facebook.com/idea.ca",
        instagram: "https://instagram.com/mediajasa.kg",
        twitter: "https://twitter.com/IDEACentralAsia",
        // youtube: "https://www.youtube.com/user/ruidebateorg",
    };
    return (
        <SSocialList>
            {settings?.telegram ? (
                <Item href={settings?.telegram} target="_blank">
                    <IconTelegramWhite />
                </Item>
            ) : null}
            {settings?.facebook ? (
                <Item href={settings?.facebook} target="_blank">
                    <IconFacebookWhite />
                </Item>
            ) : null}
            {settings?.instagram ? (
                <Item href={settings?.instagram} target="_blank">
                    <IconInstagramWhite />
                </Item>
            ) : null}
            {settings?.twitter ? (
                <Item href={settings?.twitter} target="_blank">
                    <IconTwitterWhite />
                </Item>
            ) : null}
            {/* {settings?.youtube ? (
                <Item href={settings?.youtube} target="_blank">
                    <IconYoutubeWhite />
                </Item>
            ) : null} */}
        </SSocialList>
    );
};

const SSocialList = styled.div`
    display: flex;
    align-items: center;
    ${down("sm")} {
    }
`;

const Item = styled.a`
    color: ${colors?.white};
    &:hover {
        color: ${colors?.blue_base};
    }
    & + a {
        margin-left: 1.2em;
        ${down("sm")} {
            /* margin-left: 0.8em; */
        }
    }
    svg {
        width: auto;
        height: 1.6em;
    }
`;

export default SocialList;
